const MuiInput =  {
  root: {
    '& input': {
      border:'none !important',
      borderRadius: '0px 4px 4px 0px !important',
    },
  },
  underline: {
    '&&&&:hover:before': {
      borderBottom: '1px solid rgba(0, 0, 0, 0)'
    },
    '&&&&:hover:after': {
      borderBottom: '1px solid rgba(0, 0, 0, 0)'
    },
    '&&&&:before': {
      borderBottom: '1px solid rgba(0, 0, 0, 0)'
    },
    '&&&&:after': {
      borderBottom: '1px solid rgba(0, 0, 0, 0)'
    },
  }
}

export default MuiInput
